

















import { Vue } from 'vue-property-decorator';
import { ContextData } from '@/store-types';

export default Vue.extend({
    data: () => ({
        menu: false
    }),
    computed: {
        title() {
            const keys = Object.keys(this.context);
            if (keys.length === 1) {
                return this.name + ': ' + (this.context as any)[keys[0]];
            }
            return this.name;
        }
    },
    props: {
        name: String,
        context: Object as () => any // ContextData
    }
});
